export enum IframeType {
  GenericIframe = "generic_iframe",
  Quiz = "quiz",
  SCMPYouTubeVideo = "scmp_youtube_video",
}

export enum VideoSource {
  SCMP = "SCMP",
}
